import TemplateView from "../../TemplateView"
import messageResource from "../../messageResource"
import NameInput from "../NameInput"
import {CustomerPanelTabs} from "./CustomerPanel"
import EditActionButton from '../../controls/task/EditActionButton'
import {EntityTextLimits} from 'constants'

export default class CustomerPanelHeader extends TemplateView {
    constructor($containerEl, $panel) {
        super($containerEl);
        this.$panel = $panel;
    }

    templateHtml() {
        return "<div class='editCustomerPanelHeader'>" +
               "  <div class='cpInfo'>" +
               "    <span class='customerName'><%-customers%></span>" +
               "  </div>" +
               "  <div class='customerNamePlaceHolder'/>" +
               "  <div class='actions'></div>" +
               "  <div class='tabs'>" +
               "    <div class='details'><span class='tabText'><%=detailsTab%></span></div>" +
               "    <div class='assignedUsers'><span class='tabText'><%=assignedUsersTab%></span></div>" +
               "    <div class='managers'><span class='tabText'><%=managersTab%></span></div>" +
               "  </div>" +
               "</div>";
    }

    shouldUpdateOnInit() {
        return false;
    }

    messageKeys() {
        return {
            customers: "common.Customer",
            placeholder: "customer.edit.name.placeholder.text",
            detailsTab: "project.edit_panel.tabs.details",
            assignedUsersTab: 'project.edit_panel.tabs.assigned_users',
            managersTab: 'project.edit_panel.tabs.managers'
        }
    }

    afterRender() {
        this.nameInput = new NameInput({
            editable: true,
            placeholder: messageResource.getMessage('customer.edit_popup.name_placeholder'),
            maxLength: EntityTextLimits.MAX_CPT_NAME,
            onChangeCb: (name) => {
                if (name !== this.customerName && name) {
                    this.nameInput.trigger('change', name)
                }
                this.nameInput.setState({
                    name,
                    invalid: !name,
                    focus: !name,
                })
            },
        }).init(this.$containerEl.find('.customerNamePlaceHolder'))

        var $actions = this.$containerEl.find(".actions");
        this.actions = new EditActionButton({
            panelEl: this.$panel,
            headerEl: this.$containerEl,
            needMove: false,
            needCopy: true,
            needDelete: true,
            copyButtonMessageKey: 'edit_panel.action.copy',
        }).init($actions);

        this.$tabs = [];
        this.$tabs[CustomerPanelTabs.DETAILS_TAB] = this.find('.details');
        this.$tabs[CustomerPanelTabs.ASSIGNED_USERS_TAB] = this.find('.assignedUsers');
        this.$tabs[CustomerPanelTabs.MANAGERS_TAB] = this.find('.managers');

        this.$assignedUsersTabTitle = this.find(".assignedUsers .tabText");
        this.$managersTabTitle = this.find(".managers .tabText");
    }

    update(config) {
        const {name, id, readOnly} = config
        this.customerName = name
        this.nameInput.setEditable(!readOnly) // don't calls update (omg)
        this.nameInput.resetName(name);
        this.id = id;

        this.actions.disableDeleteButton(this.disableDeleteButtonText(config));

        this.actions.hideMenu();

        this.actions.toggle(!readOnly)
    }

    disableDeleteButtonText(config) {
        var disableText = null;
        if (config.blockedDueToLockedTime) {
            disableText = messageResource.getMessage("customer.edit.cannot_delete_due_to_lock_time");
        }
        else if (config.blockedDueToUnavailableToModifyTimeTrack) {
            var customerText = messageResource.getMessage("common.customer");
            disableText = messageResource.getMessage(config.canManageAllUsersWithoutAutoApproved ?
                                                     "hierarchy_entity.edit_popup.cannot_delete_due_to_unavailable_modify_time_of_autoapproved_users" :
                                                     "hierarchy_entity.edit_popup.cannot_delete_due_to_unavailable_modify_time",
                    [customerText]);
        }
        return disableText;
    }
}





// WEBPACK FOOTER //
// ./web/js/panels/customer/CustomerPanelHeader.js